import classNames from "classnames";
import { Link } from "react-router-dom";
import styles from "./Icon.module.css";

interface IconProps {
  className?: string;
  name?: string;
  fill?: 0 | 1;
  size?: string;
  color?: string;
  overlayColor?: string;
  container?: {
    className?: string;
    size?: string;
    color?: string;
    style?: React.CSSProperties;
  };
  style?: React.CSSProperties;
  link?: string;
  onClick?: () => void;
}

const Icon: React.FC<IconProps> = ({
  className,
  name,
  fill = 0,
  size = "18px",
  color = "inherit",
  overlayColor = "black",
  container,
  style,
  link,
  onClick,
}) => {
  const isClickable: boolean = Boolean(link || onClick);
  const isContained: boolean = container
    ? Object.values(container).some(Boolean)
    : false;

  const children = (
    <>
      {isClickable && <span className={styles.overlay} />}
      <span
        className={classNames(
          "material-symbols-rounded",
          styles.icon,
          className
        )}
        style={
          {
            "--icon-color": color,
            "--fill": fill,
            "--size": size,
            ...style,
          } as React.CSSProperties
        }
      >
        {name}
      </span>
    </>
  );

  const containerProps = {
    className: classNames(
      isClickable && styles.clickable,
      isContained && styles.container,
      container?.className
    ),
    style: {
      "--overlay-color": overlayColor,
      "--container-size": size,
      ...(container && {
        "--container-color": container.color,
        "--container-size": container.size,
        ...container.style,
      }),
    } as React.CSSProperties,
  };

  if (onClick) {
    return (
      <button {...containerProps} onClick={onClick}>
        {children}
      </button>
    );
  } else if (link) {
    return (
      <Link {...containerProps} to={link}>
        {children}
      </Link>
    );
  } else if (container) {
    return <div {...containerProps}>{children}</div>;
  } else {
    return children;
  }
};

export { Icon };
